import { FormOutlined } from "@ant-design/icons";
import { BButton } from "components/base";
import clsx from "clsx";
import { useCallback } from "react";
import { chatStore } from "store/chatStore";
import "./SidebarNewChatButton.scss";

type SidebarNewChatButtonProps = {
  collapsed?: boolean;
  onNavigate?: () => void;
};

const SidebarNewChatButton = ({
  collapsed = false,
  onNavigate,
}: SidebarNewChatButtonProps) => {
  const handleClick = useCallback(() => {
    chatStore.startNewChat();
    onNavigate?.();
  }, [onNavigate]);

  return (
    <BButton
      type="default"
      block={!collapsed}
      className={clsx(
        "sidebar-new-chat-button",
        collapsed && "sidebar-new-chat-button--collapsed",
      )}
      icon={<FormOutlined />}
      onClick={handleClick}
      aria-label="Tra cứu mới"
      title="Tra cứu mới"
    >
      {!collapsed ? "Tra cứu mới" : null}
    </BButton>
  );
};

export default SidebarNewChatButton;
